import { render, staticRenderFns } from "./MisBoletos.vue?vue&type=template&id=28ff7bf8&scoped=true&"
import script from "./MisBoletos.vue?vue&type=script&lang=js&"
export * from "./MisBoletos.vue?vue&type=script&lang=js&"
import style0 from "./MisBoletos.vue?vue&type=style&index=0&id=28ff7bf8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ff7bf8",
  null
  
)

export default component.exports